/**
 * The bar across the top of a draft preview.
 *
 * Not decoration. A preview URL is a real, working, shareable link to the live
 * site, and the whole point of the feature is that the page looks exactly like
 * the published article — which means there is otherwise nothing on screen to
 * distinguish "the copy we are still arguing about" from "the copy that is
 * live". Someone will paste one of these into a group chat; the banner is what
 * stops that from reading as a launch.
 *
 * The response also carries noindex and no-store (applyPreviewResponseHeaders),
 * so this is the human half of a protection whose machine half is already
 * handled.
 */
export default function DraftPreviewBanner() {
  return (
    <div
      role="status"
      className="sticky top-0 z-50 bg-amber-400 px-4 py-2 text-center text-sm font-semibold text-amber-950"
      data-log-seen="blog_draft_preview"
    >
      Draft preview — this page is not published. The link expires shortly and is not indexed.
    </div>
  );
}
